import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-propertiesregister',
  templateUrl: './propertiesregister.component.html',
  styleUrls: ['./propertiesregister.component.css']
})
export class PropertiesregisterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/propertiesregister/propertiesregister.component.ts